module.exports = __webpack_public_path__ + "images/hem-hushall.34041034.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/hem-hushall.jpg
// module id = 714a0f23
// module chunks = 6 16